import { TApplicationState } from 'shared/types/redux';

export const newbuildingDisplayNameSelector = (state: TApplicationState) => {
  return state.newbuilding.displayName;
};
